import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMemberTracking } from '../../hooks/useMemberTracking';

/**
 * Automatic page view tracking for member app
 * Tracks every route navigation to understand member app usage patterns
 *
 * This component should be mounted once at the app root level
 */
export function MemberAppTracker() {
  const location = useLocation();
  const { trackPageView } = useMemberTracking();

  useEffect(() => {
    // Track all member app routes (not club-admin routes)
    if (!location.pathname.startsWith('/club-admin')) {
      trackPageView(location.pathname);

      if (import.meta.env.DEV) {
        console.log(`Member App Analytics: Tracking page view - ${location.pathname}`);
      }
    }
  }, [location.pathname, trackPageView]);

  return null; // This component doesn't render anything
}
